import * as t from 'io-ts';
import { QuoteDynamicType } from './quote';

export const QuotesListDynamicType = t.interface({
    quotes: t.array(QuoteDynamicType)
});

export type QuotesList = t.TypeOf<typeof QuotesListDynamicType>;
